export default __webpack_public_path__ + "static/media/FromScratchSS.5afebada.png";